/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
import React from "react";
import { Link } from "react-router-dom";
import {
    ShimmerBadge,
    ShimmerButton,
    ShimmerTitle,
    ShimmerThumbnail,
    ShimmerSectionHeader,
    ShimmerCircularImage,
    ShimmerText,
} from "react-shimmer-effects";

export default function Skeleton() {
    return (

        <>
            <div class="mt-5 ">
                <div class="flex justify-between items-center p-2 rounded-sm border border-[#c2dcef] bg-[#eef7fe] leading-6 mx-10">
                    <div class="flex items-center w-full">
                        <div class="text-left max-w-[75%]">
                            <ShimmerBadge width={350} />
                        </div>
                    </div>
                    <div class="ml-[20px] text-right w-[36%]">
                        <ShimmerBadge width={250} />
                    </div>
                </div>

                {/* <!--Tabs navigation--> */}
                <ul
                    class="mx-10 mt-[5px] flex list-none flex-row border border-[#e7e7e7] justify-between  pt-[10px] z-30 top-[70px] sticky bg-[#fff] px-3"
                    role="tablist"
                    data-te-nav-ref
                >
                    <li role="presentation" style={{'width':'185px'}}>
                        <a
                            href="#tabs-basic_details"

                            class="relative block institutionList1 bottom-border-navBlack text font-normal text-[#031624] px-1 mr-20 data-[te-nav-active]:text-[#031624] data-[te-nav-active]:font-semibold h-[38px]"
                            data-te-toggle="pill"
                            data-te-target="#tabs-institutionDetails"
                            data-te-nav-active
                            role="tab"
                            aria-controls="tabs-institutionDetails"
                            aria-selected="false"
                        >
                            <ShimmerBadge width={125} margin-bottom={'10px'} style={{ 'margin-bottom': '10px' }} />
                        </a>
                    </li>
                    <li role="presentation" style={{'width':'185px'}}>
                        <a
                            href="#tabs-contact_details"
                            class="institutiondetails1 relative block text-lg font-normal text-[#031624] px-1 pb-2.5 mr-20 data-[te-nav-active]:text-[#031624] data-[te-nav-active]:font-semibold h-[38px]"
                            data-te-toggle="pill"
                            data-te-target="#tabs-institutionuserList"
                            role="tab"
                            aria-controls="tabs-institutionuserList"
                            aria-selected="false"
                        >
                            <ShimmerBadge width={125} margin-bottom={'10px'} />
                        </a>
                    </li>
                    <li role="presentation" style={{'width':'185px'}}>
                        <a
                            href="#tabs-academic_details"
                            class="institutiondetails1 relative block text-lg font-normal text-[#031624] px-1 pb-2.5 mr-20 data-[te-nav-active]:text-[#031624] data-[te-nav-active]:font-semibold h-[38px]"
                            data-te-toggle="pill"
                            data-te-target="#tabs-institutionuserList"
                            role="tab"
                            aria-controls="tabs-institutionuserList"
                            aria-selected="false"
                        >
                            <ShimmerBadge width={125} />
                        </a>
                    </li>
                    <li role="presentation" style={{'width':'185px'}}>
                        <a
                            href="#tabs-student_statement"
                            class="institutiondetails1 relative block text-lg font-normal text-[#031624] px-1 pb-2.5 mr-20 data-[te-nav-active]:text-[#031624] data-[te-nav-active]:font-semibold h-[38px]"
                            data-te-toggle="pill"
                            data-te-target="#tabs-institutionuserList"
                            role="tab"
                            aria-controls="tabs-institutionuserList"
                            aria-selected="false"
                        >
                            <ShimmerBadge width={125} />
                        </a>
                    </li>
                    <li role="presentation" style={{'width':'185px'}}>
                        <a
                            href="#tabs-attendace_details"
                            class="institutiondetails1 relative block text-lg font-normal text-[#031624] px-1 pb-2.5 mr-20 data-[te-nav-active]:text-[#031624] data-[te-nav-active]:font-semibold h-[38px]"
                            data-te-toggle="pill"
                            data-te-target="#tabs-institutionuserList"
                            role="tab"
                            aria-controls="tabs-institutionuserList"
                            aria-selected="false"
                        >
                            <ShimmerBadge width={125} />
                        </a>
                    </li>
                    <li role="presentation" style={{'width':'185px'}}>
                        <a
                            href="#tabs-academic_reports"
                            class="institutiondetails1 relative block text-lg font-normal text-[#031624] px-1 pb-2.5 data-[te-nav-active]:text-[#031624] data-[te-nav-active]:font-semibold h-[38px]"
                            data-te-toggle="pill"
                            data-te-target="#tabs-institutionuserList"
                            role="tab"
                            aria-controls="tabs-institutionuserList"
                            aria-selected="false"
                        >
                            <ShimmerBadge width={125} />
                        </a>
                    </li>
                </ul>
                <div class="scroll-bar tabbedPgListDiv student">
                    {/* <!--Tabs content--> */}
                    <div class="mt-5">
                        <div
                            class="opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
                            id="tabs-institutionDetails"
                            role="tabpanel"
                            aria-labelledby="tabs-institutionDetails-tab"
                        >
                            <div class="w-[800px] mx-auto border border-[#e7e7e7] rounded">
                                <div class="flex">
                                </div>
                                <div class=" p-4 mt-1 pb-[8px]">
                                    <div class="flex -mx-2">
                                        <div class="w-[55%] px-2">
                                            <div class="w-full ">
                                                <div class="flex items-center">
                                                    <h5 class="text-f7 font-semibold text-[#000000] break-words">
                                                        <ShimmerThumbnail width={90} height={90} />
                                                    </h5>
                                                    <div class="ml-7 mt-2">
                                                        <p class="text-f7 font-semibold text-[#031624] break-words">
                                                            <ShimmerBadge width={100} />
                                                        </p>
                                                        <p class="text-f7 font-semibold text-[#031624] break-words">
                                                            <ShimmerBadge width={120} />
                                                        </p>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="flex items-start mt-2">
                                                        <p class="text-f7 font-normal text-[#031624] min-w-[200px]">
                                                            <ShimmerBadge width={110} />
                                                        </p>
                                                        <div class="flex items-center">
                                                            <p class="text-f7 font-semibold text-[#031624] break-words">
                                                                <ShimmerBadge width={100} />
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="flex items-start mt-2">
                                                        <p class="text-f7 font-normal text-[#031624] min-w-[200px]">
                                                            <ShimmerBadge width={110} />
                                                        </p>
                                                        <div class="flex items-center">
                                                            <p class="text-f7 font-semibold text-[#031624] break-words truncate">
                                                                <ShimmerBadge width={200} />
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="flex items-center mt-2">
                                                        <p class="text-f7 font-normal text-[#031624] min-w-[200px]">
                                                            <ShimmerBadge width={110} />
                                                        </p>
                                                        <div class="flex items-center">
                                                            <p class="text-f7 font-semibold text-[#031624] break-words">
                                                                <ShimmerBadge width={200} />
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="flex items-center mt-2">
                                                        <p class="text-f7 font-normal text-[#031624] min-w-[200px]">
                                                            <ShimmerBadge width={110} />
                                                        </p>
                                                        <div class="flex items-center">
                                                            <p class="text-f7 font-semibold text-[#031624] break-words">
                                                                <ShimmerBadge width={200} />
                                                            </p>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                        <div class="w-[40%] px-2">
                                            <div class="w-full">
                                                <div>
                                                    <div class="flex items-start mt-14">
                                                        <p class="text-f7 font-normal text-[#031624] min-w-[160px]">
                                                            <ShimmerBadge width={100} />
                                                        </p>
                                                        <div class="flex items-center">
                                                            <p class="text-f7 font-semibold text-[#031624] break-words">
                                                                <ShimmerBadge width={150} />
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="flex items-start mt-2">
                                                        <p class="text-f7 font-normal text-[#031624] min-w-[160px]">
                                                            <ShimmerBadge width={100} />
                                                        </p>
                                                        <div class="flex items-center">
                                                            <p class="text-f7 font-semibold text-[#031624] break-words truncate">
                                                                <ShimmerBadge width={150} />
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="flex items-start mt-2">
                                                        <p class="text-f7 font-normal text-[#031624] min-w-[160px]">
                                                            <ShimmerBadge width={100} />
                                                        </p>
                                                        <div class="flex items-center">
                                                            <p class="text-f7 font-semibold text-[#031624] break-words truncate">
                                                                <ShimmerBadge width={150} />
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="flex items-start mt-2">
                                                        <p class="text-f7 font-normal text-[#031624] min-w-[160px]">
                                                            <ShimmerBadge width={100} />
                                                        </p>
                                                        <div class="flex items-center">
                                                            <p class="text-f7 font-semibold text-[#031624] break-words truncate">
                                                                <ShimmerBadge width={150} />
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="flex items-center mt-2">
                                                        <p class="text-f7 font-normal text-[#031624] min-w-[160px]">
                                                            <ShimmerBadge width={100} />
                                                        </p>
                                                        <div class="flex items-center">
                                                            <p class="text-f7 font-semibold text-[#031624] break-words">
                                                                <ShimmerBadge width={150} />
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
}
